import React from "react";


const Approve = () => {
    return (
        <svg className="fill-current w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
            <path d="M14.5312 15.75C14.5312 16.0625 14.2813 16.3125 13.9688 16.3125H2.46875C2.15625 16.3125 1.90625 16.0625 1.90625 15.75V4.25C1.90625 3.9375 2.15625 3.6875 2.46875 3.6875H12.9062L14.1562 2.28125C14.0938 2.28125 14.0625 2.28125 14 2.28125H2.46875C1.40625 2.28125 0.5 3.15625 0.5 4.25V15.7812C0.5 16.875 1.375 17.75 2.46875 17.75H14C15.0625 17.75 15.9688 16.875 15.9688 15.7812V4.53125L14.5625 6.09375V15.75H14.5312Z" fill="currentColor" />
            <path d="M17.0626 1.15629C16.7813 0.906292 16.3438 0.906292 16.0626 1.21879L14.9063 2.50004L13.8438 3.68754L7.87505 10.375L4.9063 7.65629C4.62505 7.40629 4.18755 7.40629 3.9063 7.68754C3.6563 7.96879 3.6563 8.40629 3.93755 8.68754L7.43755 11.875C7.56255 12 7.75005 12.0625 7.9063 12.0625H7.93755C8.12505 12.0625 8.31255 11.9688 8.43755 11.8438L14.5313 5.03129L15.8126 3.59379L17.1251 2.12504C17.3751 1.84379 17.3751 1.40629 17.0626 1.15629Z" fill="currentColor" />
        </svg>
    );
};

export default Approve;


